import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { TuiRoot } from '@taiga-ui/core';
import { filter, map } from 'rxjs';

import { DashboardAccessService } from '@core/analytics-api/dashboard-access.service';
import { findDashboard } from '@shared/dashboards/dashboard-registry';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, TuiRoot],
  template: `
    <tui-root>
      <router-outlet />

      @if (checkingAccess()) {
        <div class="bootstrap-fallback" role="status">
          <span class="bootstrap-fallback__mark"></span>
          <strong>Васта: Аналитика</strong>
          <small>Проверяем доступ к дашбордам…</small>
        </div>
      }
    </tui-root>
  `,
})
export class App {
  private readonly access = inject(DashboardAccessService);

  /** Адрес после первой завершённой навигации; до неё — `null`. */
  private readonly url = toSignal(
    inject(Router).events.pipe(
      filter((event): event is NavigationEnd => event instanceof NavigationEnd),
      map((event) => event.urlAfterRedirects),
    ),
    { initialValue: null },
  );

  /**
   * Пока проверяется доступ — та же заставка, что до запуска приложения, с другой надписью:
   * главная и дашборды появляются целиком, без мигания. Личный кабинет доступ не ждёт,
   * поэтому на нём заставка не держится.
   */
  readonly checkingAccess = computed(() => {
    if (this.access.state().kind !== 'loading') {
      return false;
    }

    const url = this.url();

    if (url === null) {
      return true;
    }

    return url.split('?')[0] === '/' || findDashboard(url) !== undefined;
  });
}
